// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2UxKo","notes":"Notes_notes__2iKqi","note":"Notes_note__3kBqQ","markdown":"Notes_markdown__77VAY"};